import { z } from 'zod';

/**
 * Výběr v reportu „Evidence cen" držený v URL — dá se poslat odkazem a přežije reload.
 *
 * Schéma visí na společné route reportů, ostatní reporty ty parametry ignorují. `.catch` místo
 * chyby: rozbitý odkaz má report otevřít bez výběru, ne shodit stránku.
 */
export const priceEvidenceSearchSchema = z.object({
  periods: z.array(z.string()).optional().catch(undefined),
  supplierId: z.coerce.number().optional().catch(undefined),
  organizationId: z.coerce.number().optional().catch(undefined),
  userId: z.coerce.number().optional().catch(undefined),
  orderId: z.coerce.number().optional().catch(undefined),
  productEcid: z.string().optional().catch(undefined),
  /** Stránka položek, od 0. Při změně výběru se vrací na první. */
  itemsPage: z.coerce.number().int().min(0).optional().catch(undefined),
});

export type PriceEvidenceSearch = z.infer<typeof priceEvidenceSearchSchema>;

/** Rozměry, podle kterých se v tabulkách vybírá. */
export type PriceEvidenceSelectionKey = 'supplierId' | 'organizationId' | 'userId' | 'orderId' | 'productEcid';

export const SELECTION_KEYS: PriceEvidenceSelectionKey[] = ['supplierId', 'organizationId', 'userId', 'orderId', 'productEcid'];

/** Minulý měsíc `YYYY_MM` — výchozí období, report se nejčastěji čte za něj. */
export const previousPeriod = (): string => {
  const now = new Date();
  const month = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  return `${month.getFullYear()}_${String(month.getMonth() + 1).padStart(2, '0')}`;
};
